import { render } from "./UserAdd.vue?vue&type=template&id=46b5883a"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"
script.render = render

export default script